import type { AvailabilityMode, WizardStep } from './hooks/useAvailabilityWizard';

type LabelEntry = { label: string; active: string };

const STEP_LABELS: Record<AvailabilityMode, Record<WizardStep, LabelEntry>> = {
  recurring: {
    0: { label: 'wizard.steps.start', active: 'wizard.steps.choosingServiceType' },
    1: { label: 'wizard.steps.type', active: 'wizard.steps.selectingType' },
    2: { label: 'wizard.steps.services', active: 'wizard.steps.selectingServices' },
    3: { label: 'wizard.steps.schedule', active: 'wizard.steps.settingSchedule' },
    4: { label: 'wizard.steps.review', active: 'wizard.steps.reviewing' },
    5: { label: '', active: '' },
  },
  date_range: {
    0: { label: 'wizard.steps.start', active: 'wizard.steps.choosingServiceType' },
    1: { label: 'wizard.steps.type', active: 'wizard.steps.selectingType' },
    2: { label: 'wizard.steps.services', active: 'wizard.steps.selectingServices' },
    3: { label: 'wizard.steps.dates', active: 'wizard.steps.selectingDates' },
    4: { label: 'wizard.steps.review', active: 'wizard.steps.reviewing' },
    5: { label: '', active: '' },
  },
  one_time: {
    0: { label: 'wizard.steps.start', active: 'wizard.steps.choosingServiceType' },
    1: { label: 'wizard.steps.type', active: 'wizard.steps.selectingType' },
    2: { label: 'wizard.steps.services', active: 'wizard.steps.selectingServices' },
    3: { label: 'wizard.steps.dateTime', active: 'wizard.steps.selectingDateTime' },
    4: { label: 'wizard.steps.review', active: 'wizard.steps.reviewing' },
    5: { label: '', active: '' },
  },
};

const FIRST_TIME_STEP_LABELS: Record<WizardStep, LabelEntry> = {
  0: { label: 'wizard.steps.welcome', active: 'wizard.steps.gettingStarted' },
  1: { label: 'wizard.steps.service', active: 'wizard.steps.creatingService' },
  2: { label: 'wizard.steps.team', active: 'wizard.steps.selectingTeam' },
  3: { label: 'wizard.steps.schedule', active: 'wizard.steps.settingSchedule' },
  4: { label: 'wizard.steps.review', active: 'wizard.steps.reviewing' },
  5: { label: '', active: '' },
};

const GROUP_FLOW_STEP_LABELS: Record<WizardStep, LabelEntry> = {
  0: { label: 'wizard.steps.start', active: 'wizard.steps.choosingServiceType' },
  1: { label: 'wizard.steps.groupService', active: 'wizard.steps.choosingGroupService' },
  2: { label: 'wizard.steps.schedule', active: 'wizard.steps.settingSchedule' },
  3: { label: 'wizard.steps.review', active: 'wizard.steps.reviewing' },
  4: { label: '', active: '' },
  5: { label: '', active: '' },
};

export function getStepLabelKey(
  currentStep: WizardStep,
  mode: AvailabilityMode,
  isFirstTimeFlow: boolean,
  isGroupFlow: boolean,
): LabelEntry | undefined {
  if (isFirstTimeFlow) return FIRST_TIME_STEP_LABELS[currentStep];
  if (isGroupFlow) return GROUP_FLOW_STEP_LABELS[currentStep];
  return STEP_LABELS[mode][currentStep];
}
